// extracted by mini-css-extract-plugin
export var bodySections = "_cd-8";
export var gray = "_cd-7";
export var green = "_cd-4";
export var iconContainer = "_cd-9";
export var iconWidgetContainer = "_cd-1";
export var phoneIcon = "_cd-2";
export var red = "_cd-5";
export var statusDot = "_cd-3";
export var widgetContainer = "_cd-0";
export var yellow = "_cd-6";